// 开直播
const dyRoutes = Array.from({ length: 12 }, (_, i) => ({
  path: `liveBroadcast/dy/index${i + 1}`,
  name: `liveBroadcast/dy/Index${i + 1}`,
  component: () => import(`@/views/entertainment/liveBroadcast/dy/index${i + 1}.vue`)
}))
const branch1dyhRoutes = Array.from({ length: 4 }, (_, i) => ({
  path: `liveBroadcast/dy/branch1/index${i + 1}`,
  name: `liveBroadcast/dy/branch1/Index${i + 1}`,
  component: () => import(`@/views/entertainment/liveBroadcast/dy/branch1/index${i + 1}.vue`)
}))
const branch2dyRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `liveBroadcast/dy/branch2/index${i + 1}`,
  name: `liveBroadcast/dy/branch2/Index${i + 1}`,
  component: () => import(`@/views/entertainment/liveBroadcast/dy/branch2/index${i + 1}.vue`)
}))

const wxRoutes = Array.from({ length: 19 }, (_, i) => ({
  path: `liveBroadcast/wx/index${i + 1}`,
  name: `liveBroadcast/wx/Index${i + 1}`,
  component: () => import(`@/views/entertainment/liveBroadcast/wx/index${i + 1}.vue`)
}))
const branch1wxRoutes = Array.from({ length: 5 }, (_, i) => ({
  path: `liveBroadcast/wx/branch1/index${i + 1}`,
  name: `liveBroadcast/wx/branch1/Index${i + 1}`,
  component: () => import(`@/views/entertainment/liveBroadcast/wx/branch1/index${i + 1}.vue`)
}))
const branch2wxRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `liveBroadcast/wx/branch2/index${i + 1}`,
  name: `liveBroadcast/wx/branch2/Index${i + 1}`,
  component: () => import(`@/views/entertainment/liveBroadcast/wx/branch2/index${i + 1}.vue`)
}))
const branch3wxRoutes = Array.from({ length: 4 }, (_, i) => ({
  path: `liveBroadcast/wx/branch3/index${i + 1}`,
  name: `liveBroadcast/wx/branch3/Index${i + 1}`,
  component: () => import(`@/views/entertainment/liveBroadcast/wx/branch3/index${i + 1}.vue`)
}))
const xhsRoutes = Array.from({ length: 16 }, (_, i) => ({
  path: `liveBroadcast/xhs/index${i + 1}`,
  name: `liveBroadcast/xhs/Index${i + 1}`,
  component: () => import(`@/views/entertainment/liveBroadcast/xhs/index${i + 1}.vue`)
}))
const branch1xhsRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `liveBroadcast/xhs/branch1/index${i + 1}`,
  name: `liveBroadcast/xhs/branch1/Index${i + 1}`,
  component: () => import(`@/views/entertainment/liveBroadcast/xhs/branch1/index${i + 1}.vue`)
}))
const branch2xhsRoutes = Array.from({ length: 4 }, (_, i) => ({
  path: `liveBroadcast/xhs/branch2/index${i + 1}`,
  name: `liveBroadcast/xhs/branch2/Index${i + 1}`,
  component: () => import(`@/views/entertainment/liveBroadcast/xhs/branch2/index${i + 1}.vue`)
}))


import liveBroadcastIndex from '@/views/entertainment/liveBroadcast/index'



export default {
  path: '/entertainment',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'liveBroadcast/index',
        name: 'liveBroadcastIndex',
        component: liveBroadcastIndex
      },
    // 开直播，开始
    ...dyRoutes,
    ...branch1dyhRoutes,
    ...branch2dyRoutes,
    ...wxRoutes,
    ...branch1wxRoutes,
    ...branch2wxRoutes,
    ...branch3wxRoutes,
    ...xhsRoutes,
    ...branch1xhsRoutes,
    ...branch2xhsRoutes,






    // 开直播，结束


  ],
};
